import React, { Suspense, useState } from "react";
import Pagination from "react-paginate";

import BlogFeaturedimage from "images/blog/blog-featured-image.jpg";
import ArrowRight from "images/icons/right-arrow-dark.inline.svg";

import { useBannerDetails } from "../../hooks/useBannerManager";
import { useGviconfigurator } from "../../hooks/useSiteConfigurator";
import { addTrailingSlash } from "../../utils/commonFunctions";
import MainBlogCard from "../cards/mainBlogCard";
import Newsletter from "../newsletter";
import NewsletterWidget from "../newsletterWidget";
import EnquireCard from "../shared/enquireCard";

const ScholarshipBanner = React.lazy(() => import("../home/scholarshipBanner"));

const BlogPageComponent = ({ data }) => {
  const genericDetails = data?.genericDetails;
  const {
    title: stickyTitle,
    image: stickyImage,
    desc: stickyDesc
  } = useBannerDetails() ?? {};

  const configurator = useGviconfigurator();
  const { grants_banner_config } = configurator ?? {};

  const ukHomebannerConfig = grants_banner_config?.homepage ?? {};

  const banner = useBannerDetails("homepage");

  //replace title with banner title if available
  const displayBannerTitle = banner?.title || "";
  const displayBannerDesc = banner?.desc || "";

  const genericGlobalConfig =
    genericDetails?.globalProgramConfig?.acfGenericGlobalConfig ?? {};

  const scholarshipTitle =
    genericGlobalConfig?.exclusiveOfferTitle ??
    "Get up to EXCLUSIVE_OFFER off your program";
  const scholarshipDescription =
    genericGlobalConfig?.exclusiveOfferDescription ??
    "When you join a climate research internship by 30 November";
  const scholarshipCtaLink =
    genericGlobalConfig?.exclusiveOfferLink ?? "/application-form";

  const enquireCardDetails = {
    cardTitle: null,
    enquireCardImg: stickyImage,
    cardDesc:
      `<div>${stickyTitle || ""}</div><div class='font-normal font-body text-sm pt-4'>${stickyDesc || ""}</div>` ??
      "",
    cardBookDesc: null,
    shareButton: false
  };

  const POSTS_PER_PAGE = 6;

  const [currentPage, setCurrentPage] = useState(0);
  const blogPosts = data?.allWpPost?.nodes;

  const handlePageClick = (data) => {
    const currentPage = data.selected;
    setCurrentPage(currentPage);
  };

  const currentPosts = blogPosts?.slice(
    currentPage * POSTS_PER_PAGE,
    (currentPage + 1) * POSTS_PER_PAGE
  );

  const pageCount = Math.ceil(blogPosts?.length / POSTS_PER_PAGE);

  return (
    <>
      <Suspense>
        <div className="bg-yellow-lighter planet:bg-gray-darkest">
          <div className="w-full pb-10 pt-10 sm:pt-20 mx-auto md:w-4/5 sm:pb-24">
            <div className="relative w-11/12 mx-auto md:w-full sticky-wrapper">
              <div className="w-full md:blog-section-w sm:py-11 md:pt-0 md:pr-10">
                {currentPosts && currentPosts?.length > 0 && (
                  <>
                    <div className="cards-wrapper">
                      {currentPosts?.map((post, i) => {
                        const date = new Date(post?.date).toLocaleDateString(
                          "en-GB",
                          {
                            day: "numeric",
                            month: "long",
                            year: "numeric"
                          }
                        );
                        const count = 2;

                        return (
                          <>
                            <MainBlogCard
                              key={i}
                              postImage={
                                post?.featuredImage?.node.sourceUrl ??
                                BlogFeaturedimage
                              }
                              title={post?.title}
                              link={addTrailingSlash(post?.slug)}
                              blurb={post?.blogPosts?.blurb}
                              author={post?.author?.node?.name}
                              date={date}
                              descWidth="w-full"
                              cardClickable={true}
                            />
                          </>
                        );
                      })}
                    </div>
                    <div className="py-6 flex items-center justify-center mx-auto">
                      <Pagination
                        previousLabel={
                          <ArrowRight className="stroke-gray-generic planet:group-hover:stroke-black-lighter mr-1 mt-3 w-4 h-4 rotate-180" />
                        }
                        nextLabel={
                          <ArrowRight className="stroke-gray-generic planet:group-hover:stroke-black-lighter ml-1 mt-3 w-4 h-4" />
                        }
                        breakLabel={"..."}
                        pageCount={pageCount}
                        marginPagesDisplayed={0}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        breakClassName={
                          "py-1 px-4 planet:bg-gray-darker planet:text-gray-generic text-base planet:rounded-md"
                        }
                        containerClassName={
                          "flex planet:text-gray-generic gap-2 rounded-sm"
                        }
                        pageClassName={
                          "py-2 px-4 planet:bg-gray-darker planet:text-gray-generic text-base planet:rounded-md"
                        }
                        subContainerClassName={""}
                        activeClassName={
                          "active py-2 px-4 planet:bg-gray-standard planet:text-gray-generic text-base planet:rounded-md"
                        }
                        forcePage={currentPage}
                        prevPageRel={null}
                      />
                    </div>
                  </>
                )}
              </div>

              <div className="hidden w-full sm:absolute sm:h-full sm:w-auto sm:flex sm:top-0 sm:right-0">
                <div className="relative w-[290px]">
                  <div className={`card-sticky-container absolute w-[290px]`}>
                    <NewsletterWidget />
                    <EnquireCard
                      applyNow={"/application-form/"}
                      enquireCardDetails={enquireCardDetails}
                      cardStyle={"sm:w-[290px]"}
                      cardDefaultWidth={""}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Newsletter />
      </Suspense>
    </>
  );
};

export default BlogPageComponent;
